import ShouldKnowSection from './ShouldKnowSection';
export default ShouldKnowSection;
